/**
 * AI对话框展示搜索新闻的组件
 * zxw
 * 2024-05-15
 */

import React, { useState } from 'react';
import { 
    DownOutlined,
    UpOutlined,
 } from '@ant-design/icons';

const AssistantBoxNews = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isHover, setIsHover] = useState(false);
    return (
        <div style={{ padding: '15px 15px 0 15px'}}>
            <div style={{
                cursor: 'pointer',
                padding: '10px 10px',
                backgroundColor: isHover?'#F3F5FD':'#F8F8FA',
                borderRadius: 5,
                width: 'auto',
                display: 'inline-block',
            }} 
                onMouseEnter={()=>{setIsHover(true)}}
                onMouseLeave={()=>{setIsHover(false)}}
                onClick={()=>{setIsOpen(!isOpen)}}>找到了&nbsp;{props.networkDataList.length}&nbsp;篇消息作为参考：<span style={{marginLeft: 10 }}>{isOpen?<UpOutlined style={{ fontSize: 12 }} />:<DownOutlined style={{ fontSize: 12 }} />}</span></div>
            {
                isOpen?<div style={{
                    padding: '12px 10px',
                    backgroundColor: '#F8F8FA',
                    borderRadius: 5,
                    marginTop: 10,
                }}>
                    <span>已为您在互联网搜索到如下相关的资料：</span>
                    <div>
                        {
                            props.networkDataList.map((item, index)=>{
                                return <div key={index} style={{
                                    marginTop: 3,
                                    marginBottom: 3,
                                    whiteSpace: 'nowrap',       /* 确保文本在一行内显示 */
                                    overflow: 'hidden',         /* 超出部分隐藏 */
                                    textOverflow: 'ellipsis'    /* 使用省略号表示被截断的文本 */
                                }}>
                                    <span>找到了第&nbsp;{index + 1}&nbsp;篇消息：</span><a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a>
                                </div>
                            })
                        }
                    </div>
                </div>:''
            }
        </div>
    );
}

export default AssistantBoxNews;